import * as React from 'react';
import { Card, Grid, RadioSwitch, FormCell } from 'ui-toolkit';
import { IBankruptcyData } from '../../../ui-toolkit/orders/interfaces/titleReport/IBankruptcy';

interface IProps {
  data: IBankruptcyData;
  title?: string;
  onFormChange: (dataPath: string, newData: any) => void;
}

export enum EBankruptcyResultValues {
  clear = 'clear',
  found = 'found',
}

export const BankruptcyInformation: React.FC<IProps> = ({ title = 'Bankruptcy Information', data, onFormChange }) => {
  const onSwitchBankruptcy = (event: React.ChangeEvent<HTMLInputElement>) => {
    const element = event.currentTarget as HTMLInputElement;
    const value = element.value === EBankruptcyResultValues.clear;
    onFormChange('bankruptcyInformation.clear', value);
  };

  return (
    <Card title={title}>
      <Grid columnCount={2}>
        <FormCell label={'Result'}>
          <RadioSwitch
            name={'result-bankruptcy'}
            onChange={(event) => onSwitchBankruptcy(event)}
            value={data.clear ? EBankruptcyResultValues.clear : EBankruptcyResultValues.found}
            options={[
              { label: 'Clear', value: EBankruptcyResultValues.clear },
              { label: 'Found', value: EBankruptcyResultValues.found },
            ]}
          />
        </FormCell>
      </Grid>
    </Card>
  );
};
